<template>
  <b-dropdown left menu-class="pb-0" variant="link" no-caret>
    <template #button-content>
      <a class="text-primary">
        <span>{{ $t('prices_price') }}</span>
        <ArrowSvg class="ml-2"/>
        <!--        <span class="notification-bubble" v-if="selected.length > 0">{{ selected.length }}</span>-->
      </a>
    </template>
    <div class="pt-3">
      <div v-for="p in pricesFiltered"
           :key="`doctor-filter-opt-${p.id}`"
           class="px-3"
           style="width: 200px;">
        <CheckboxGroup :label="p.title"
                       :checkboxvalue="p.id"
                       :class="{ 'opacity-50': !p.active }"
                       :fid="`checkbox-w-${p.id}`"
                       v-model="selected"/>
      </div>
      <a class="mt-3 btn-themed w-100 d-block text-center btn-themed-squared"
         @click="apply">
        {{ $t('apply') }}
      </a>
    </div>
  </b-dropdown>
</template>

<script setup>

import { useStore } from "vuex"
import CheckboxGroup from "@/components/form/CheckboxGroup"
import ArrowSvg from '@/assets/svg-vue/general/arrow_down.svg'
import {copyObject} from "@/extensions/prototypes/prototypes"
import {useRoute, useRouter } from "vue-router"
import {computed, onMounted, ref, watch, nextTick } from "vue"

const route = useRoute()
const router = useRouter()
const store = useStore()

const selected = ref([])
const watcher = ref(false)

const storageKey = 'priceFiltersForServices'

const prices = computed(() => store.state.auth.prices)
const pricesFiltered = computed(() => {
  const pricesCopy = copyObject(prices.value)
  return pricesCopy.sort((a, b) => Number(b.active) - Number(a.active))
})

const parseRoute = async () => {
  if(route.query.filters) {
    let js = JSON.parse(route.query.filters)
    if(js.price_id) {
      let f = js.price_id
      if(f.type === 'contains') {
        selected.value = f.condition
      } else {
        if(f.type === 'equals') {
          selected.value = [f.condition]
        }
      }
    } else {
      selected.value = []
    }
  }
  await nextTick()
  watcher.value = true
  setInitialPrices()
}

const setInitialPrices = () => {
  if(route.query.filters) return

  const savedStr = window.localStorage.getItem(storageKey)
  if(savedStr) {
    selected.value = JSON.parse(savedStr)
  } else {
    selected.value = pricesFiltered.value.filter(item => item.active).map(obj => obj.id)
  }

  apply()
}

const apply = () => {
  if(!watcher.value) return
  let data = {}
  let arr = []
  for(const v in selected.value) {
    arr.push(selected.value[v])
  }
  data['price_id'] = {
    id:         'price_id',
    condition:  arr,
    type:       'contains',
  }
  if(arr.length === 0) {
    data = {}
  }
  store.commit('setFilters', data)
  let query = arr.length > 0 ? {
    filters: JSON.stringify(data)
  } : {}
  if(query.filters && route.query && route.query.filters && query.filters == route.query.filters) {
    return
  }
  window.localStorage.setItem(storageKey, JSON.stringify(selected.value))
  router.push({
    path: route.path,
    query: query
  }).catch()
}

onMounted(() => {
  parseRoute()
})

watch(route, () => {
  if(watcher.value) {
    parseRoute()
  }
})
</script>

<style scoped lang="scss">
.notification-bubble {
  right: 14px;
}
.btn-themed {
  border-top-left-radius:  0;
  border-top-right-radius:  0;
}
</style>
